import { useEffect, useState, useCallback } from 'react'
import { Modal, Button, Group, Stack, Text, Alert, Loader } from '@mantine/core'
import { showNotification } from '../util/notifications'

export default function ProgressModal(props) {

    const [loading, setLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [abortController] = useState(new AbortController())
    const { opened, onClose, text, action, ...rest } = props

    const performAction = useCallback(async () => {
        setLoading(true)
        try {
            const result = await action?.()
            setLoading(false)
            onClose()
            if (result)
                showNotification({ content: result })
        } catch (error) {
            setErrorMessage(error.message)
            setLoading(false)
        }
    }, [action, onClose])

    useEffect(() => {
        if (opened) {
            performAction()
        }
    }, [opened, performAction])

    function cancel() {
        abortController.abort()
        setLoading(false)
        onClose()
    }

    return (
        <Modal
            opened={opened}
            onClose={cancel}
            title="Progress"
            centered
            closeOnClickOutside={false}
            closeOnEscape={true}
            {...rest}
            styles={{
                title: {
                    fontSize: '1.125rem',
                    fontWeight: 700,
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
                }
            }}
        >
            <Stack gap="md">
                <Text>{text}</Text>

                {loading && (
                    <Group justify="center">
                        <Loader size="md" />
                    </Group>
                )}

                {errorMessage && (
                    <Alert color="red" variant="light">
                        <Text size="sm">{errorMessage}</Text>
                    </Alert>
                )}

                <Group justify="flex-end" mt="xs">
                    <Button variant="default" onClick={cancel}>
                        Cancel
                    </Button>
                </Group>
            </Stack>
        </Modal>
    )
}